import { useState, MouseEvent } from "react";
import MoreVert from "@material-ui/icons/MoreVert";
import Info from "@material-ui/icons/Info";
import IconButton from "@material-ui/core/IconButton";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useTableActionStyles } from "./styles";
import { Link } from "react-router-dom";
// import { useLocation } from "react-router-dom";
// import AttendantDelete from "./components/delete";
// import Delete from "@material-ui/icons/Delete";
import { AttendanceLocalUser } from "../../../../../@types/attendance-local-user";

type Props = {
    attendant: AttendanceLocalUser;
}

export default function ListTableActions({ attendant }: Props) {
    // const { pathname } = useLocation();
    const { classes } = useTableActionStyles();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <IconButton onClick={handleClick} >
                <MoreVert />
            </IconButton>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                keepMounted
            >
                <MenuItem
                    component={Link}
                    onClick={handleClose}
                    className={classes.menuItem}
                    to={`/locais-de-atendimento/${attendant.unidade.slug_unidade}?active_tab=1&search=${attendant.nome_completo}`}
                >
                    <Info htmlColor="#706E7A" />
                    Informações
                </MenuItem>
                {/* <AttendantDelete
                    attendant={attendant}
                    buttonTrigger={
                        <MenuItem
                            onClick={handleClose}
                            className={classes.menuItem}
                        >
                            <Delete htmlColor="#706E7A" />
                            Excluir
                        </MenuItem>
                    }
                /> */}
            </Menu>
        </>
    );
}
